import { useEffect, useState } from "react";
import ApiService from "services/api.service";
import staticForm from "./segment-settings.json";

export const useFormMapLoader = () => {
  const [fields, setFields] = useState<any[]>(staticForm);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const loadAndUpdateFieldsWithOptions = async (mapFields: any[]) => {
    setIsLoading(true);
    try {
      const { data } = await ApiService.get<
        {
          branches: string[];
          regions: string[];
        }
      >({
        url: `/segments/meta`,
      });

      const { regions, branches } = data
      const updateDataWithMeta = mapFields.map((field: any) => {
        if (field.key === "region_name") {
          field.options = Array.isArray(field.options) ? field.options.concat(regions) : regions;
        } else if (field.key === "branch_name") {
          field.options = Array.isArray(field.options) ? field.options.concat(branches) : branches;
        }
        return field;
      })
      setFields(updateDataWithMeta);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await fetch("https://dragonhub-static-fields.s3.us-east-2.amazonaws.com/segment-settings.json", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();

      loadAndUpdateFieldsWithOptions(data)
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };
  // facing cors issues?
  useEffect(() => {
    fetchData();
  }, [])

  return { fields, isLoading, setFields };
}


